// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { getCurrentUser } from '@/authentication/api/get-current-user';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { useSuspenseQuery } from '@tanstack/react-query';

/**
 * A React hook that requests the current user from the remote API. This hook
 * suspends while the request is pending.
 */
export function useCurrentUser() {
  const { data, ...query } = useSuspenseQuery({
    retry: false,
    refetchOnMount: false,
    // Organization state such as the subscription phase is resolved by the
    // backend, so an open tab polls to pick up a change within a few minutes
    refetchInterval: TWO_MINUTES_MS,
    queryKey: ['current-user'],
    queryFn: async () => {
      const { user } = await getCurrentUser();
      Sentry.setContext('authentication', {
        authenticated: true,
        lastError: null,
      });
      Sentry.setUser({ id: user.id, email: user.email });

      return user;
    },
  });

  return { user: data, ...query };
}
